
// import {getRouter} from '@/api/common.js'
let mobileRouter = []
// async function requestMenu(){
//   let res = await getRouter()
//   // console.log(res)
//   return res
// }
// let res = requestMenu()
// console.log(res)
mobileRouter = [
  {
    path: '/',
    name: 'index',
    redirect: { path: '/home' },
  },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/mobileLayout/index.vue'),
    redirect: { name: 'indexPage' },
    children: [
      {
        path: 'indexPage',
        name: 'indexPage',
        title: '首页',
        component: () => import(/* webpackChunkName: "about" */ '../views/mobile/index/index.vue'),
        // redirect: { name: 'bigOA' },
        // component: {render: c => c('router-view')}, // 绑定一个空的routerview 否则三极路由不显示
        // children:[
        //   {
        //     path: 'bigOA',
        //     name: 'bigOA',
        //     title:'大中型组织OA',
        //     icon: 'el-icon-s-home',
        //     component: () => import('@/views/mobile/index/index.vue')
        //   },
        //   {
        //     path: '2',
        //     name: '2',
        //     title:'移动云OA',
        //     icon: 'el-icon-s-promotion',
        //     component: () => import('@/views/mobile/test/index.vue')
        //   },
        //   {
        //     path: '3',
        //     name: '3',
        //     title:'中小型组织OA',
        //     icon: 'el-icon-menu',
        //     component: () => import('@/views/mobile/test/index.vue')
        //   },
        //   {
        //     path: '4',
        //     name: '4',
        //     title:'智慧政务OA',
        //     icon: 'el-icon-s-check',
        //     component: () => import('@/views/mobile/test/index.vue')
        //   }
        // ]
      },
      {
        path: 'service',
        name: 'service',
        title: '交易信息',
        component: () => import('@/views/mobile/service/index.vue'),
      },
      {
        path: 'supplier',
        name: 'supplier',
        title: '供应商管理',
        component: () => import('@/views/mobile/supplier/index.vue'),
      },
      {
        path: 'news',
        name: 'news',
        title: '平台动态',
        component: () => import('@/views/mobile/news/index.vue'),
      },
      {
        path: 'laws',
        name: 'laws',
        title: '政策法规',
        component: () => import('@/views/mobile/laws/index.vue'),
      },
      {
        path: 'businessProcessEntrance',
        name: 'businessProcessEntrance',
        title: '园区预约',
        component: () => import('@/views/mobile/businessProcessEntrance/index.vue'),
        redirect: { name: 'chargingReservation' },
        children: [
          {
            path: 'charging',
            name: 'chargingReservation',
            title: '充电车辆预约',
            component: () => import('@/views/mobile/businessProcessEntrance/chargingReservation.vue'),
          },
          {
            path: 'parking',
            name: 'parkingReservation',
            title: '入园预约',
            component: () => import('@/views/mobile/businessProcessEntrance/parkingReservation.vue'),
          },
          {
            path: 'supplier',
            name: 'supplierRegistration',
            title: '供应商注册',
            component: () => import('@/views/mobile/businessProcessEntrance/supplierRegistration.vue'),
          }
        ]
      },
      {
        path: 'help',
        name: 'help',
        title: '操作帮助',
        component: () => import('@/views/mobile/help/index.vue'),
      },
      {
        path: 'ours',
        name: 'ours',
        title: '联系我们',
        component: () => import('@/views/mobile/ours/index.vue'),
      },

    ]
  }
]
export default mobileRouter
